import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b2e546a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "dropdown__option"
}
const _hoisted_2 = ["checked", "value", "onChange"]

import { PropType, ref } from "vue";
import IconChevronDown from "@/components/icons/IconChevronDown.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressDropdown',
  props: {
  items: Object as PropType<{ key: string; value: string }[]>,
  selected: String,
},
  emits: ["update:selected"],
  setup(__props, { emit }) {

const props = __props;




const value = ref<any>(props.items?.find((x) => x.key == props.selected));

const onChange = (event: Event, item: any) => {
  closeDropdown();
  value.value = item;
  emit("update:selected", (event.target as HTMLOptionElement).value);
};

const isOpen = ref<boolean>(false);
const openDropdown = () => {
  isOpen.value = true;
};
const closeDropdown = () => {
  isOpen.value = false;
};
const toggleDropdown = () => {
  if (isOpen.value) {
    closeDropdown();
  } else {
    openDropdown();
  }
};
const onDropdownClick = () => {
  toggleDropdown();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'dropdown--active': isOpen.value }, "dropdown"])
  }, [
    _createElementVNode("button", {
      class: "dropdown__select",
      onClick: onDropdownClick,
      type: "button"
    }, [
      _createTextVNode(_toDisplayString(value.value.value) + " ", 1),
      _createVNode(IconChevronDown, { class: "dropdown__icon" })
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: item.key
      }, [
        (value.value.key != item.key)
          ? (_openBlock(), _createElementBlock("label", _hoisted_1, [
              _createElementVNode("input", {
                checked: value.value == item.key,
                value: item.key,
                name: "dropdown",
                type: "radio",
                onChange: ($event: any) => (onChange($event, item))
              }, null, 40, _hoisted_2),
              _createTextVNode(" " + _toDisplayString(item.value), 1)
            ]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ], 2))
}
}

})